export default __webpack_public_path__ + "static/pete-teaching-4ae747a78f9c2b41aa8ecc9d756b4650.png";